var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"is-clickable",on:{"click":_vm.toggleExpanded}},[(!_vm.isExpanded)?_c('Icon',{attrs:{"name":"icon-chevron-down"}}):_vm._e(),(_vm.isExpanded)?_c('Icon',{attrs:{"name":"icon-chevron-up"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }